import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Guid } from 'guid-typescript';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { GettyOrderDetailModel } from 'src/app/admin/models/getty.order.detail.model';
import { GettyOrderService } from 'src/app/admin/services/getty.order.service';
import { AddGettyOrderModel } from 'src/app/models/add.getty.order.model';

@Component({
    selector: 'app-getty-order-import',
    templateUrl: './getty.order.import.component.html',
})

export class GettyOrderImportComponent {
    @ViewChild('fileElem', null) fileElem: any;
    @ViewChild('imageSelectionModal', { static: false }) imageSelectionModal: any;
    selfComponent: any;
    file: any;
    rowsInFile: Array<any>;
    tempModel = new AddGettyOrderModel();
    model = new AddGettyOrderModel();
    disableSave: boolean;
    progressValue: number;
    saveProgressValue: number;
    saveCompleted: number;
    closeResult: string;

    constructor(private ngxSpinner: NgxSpinnerService,
        private router: Router,
        private toastr: ToastrService,
        private gettyOrderService: GettyOrderService) {
        this.selfComponent = this;
    }

    onFileSelected(event: any): void {
        if (!event.target.files || event.target.files.length === 0) {
            return;
        }
        this.disableSave = true;
        this.file = event.target.files[0];
        this.ngxSpinner.show();
        this.model.fileKey = Guid.create().toString();
        this.model.fileName = this.file.name;


        const reader = new FileReader();
        this.model.details = new Array<GettyOrderDetailModel>();
        const this_ = this;
        reader.onload = function (progressEvent) {
            const lines = this.result.toString().split('\n');
            for (let line = 1; line < lines.length; line++) {
                const tabs = lines[line].split('\t');
                if (tabs.length > 26) {
                    const gettyOrder = new GettyOrderDetailModel();
                    gettyOrder.invoiceNumber = tabs[5];
                    gettyOrder.salesDate = tabs[6];
                    gettyOrder.customerName = tabs[13];
                    gettyOrder.assetNumber = tabs[16];
                    gettyOrder.assetDescription = tabs[17];
                    gettyOrder.grossRoyaltyInUSD = Number.parseFloat(tabs[26]);
                    this_.tempModel.details.push(gettyOrder);
                }
            }
            this_.mapWithLocalImages();
        };
        reader.readAsText(this.file);
    }

    async mapWithLocalImages() {
        this.progressValue = 0;
        const chunkOrderArray = AppUtils.getChunkArray(this.tempModel.details, 1);
        this.ngxSpinner.hide();
        for (let segment = 0; segment < chunkOrderArray.length; segment++) {
            await this.getMappings(chunkOrderArray[segment]);
        }

        this.disableSave = (this.model.details.filter(x => x.isValid === false).length > 0);
    }

    async getMappings(models: Array<GettyOrderDetailModel>) {
        return new Promise((resolve, reject) => {
            this.gettyOrderService.getMappingWithLocalImage(models).subscribe(
                async (res: any) => {
                    res.forEach(gettyOrderItem => {
                        gettyOrderItem.salesDate = AppUtils.getFormattedDate(gettyOrderItem.salesDate);
                        this.model.details.push(gettyOrderItem);
                        this.progressValue = Math.ceil((this.model.details.length * 100) / this.tempModel.details.length);
                        resolve(true);
                    });
                    this.model.details.concat(res);
                }, error => {
                    reject(false);
                    AppUtils.processErrorResponse(this.toastr, error);
                });
        });
    }

    async createOrder() {
        this.ngxSpinner.show();
        if (this.model.details.some(x => x.grossRoyaltyInUSD <= 0)) {
            this.ngxSpinner.hide();
            this.toastr.error('Invalid amount');
            return;
        }
        this.saveProgressValue = 0;
        this.saveCompleted = 0;
        const chunkOrderArray = AppUtils.getChunkArray(this.model.details, 1);
        const totalRecords = this.model.details.length;
        for (let segment = 0; segment < chunkOrderArray.length; segment++) {
            const chunkModel = new AddGettyOrderModel();
            chunkModel.fileKey = this.model.fileKey;
            chunkModel.fileName = this.model.fileName;
            chunkModel.totalRecords = totalRecords;
            chunkModel.details = chunkOrderArray[segment];
            await this.createChunkOrder(chunkModel);
        }
        this.ngxSpinner.hide();
        this.router.navigateByUrl(`${PageUrls.Admin.GettyOrder}`);
        this.toastr.success('Orders have been saved successfully.');
    }

    async createChunkOrder(model: AddGettyOrderModel) {
        return new Promise((resolve, reject) => {
            this.gettyOrderService.add(model).subscribe(
                () => {
                    this.saveProgressValue = Math.ceil((this.saveCompleted++ * 100) / this.model.details.length);
                    resolve(true);
                }, error => {
                    this.ngxSpinner.hide();
                    reject(false);
                    if (error.error) {
                        error.error.forEach(detail => {
                            const detailToUpdate = this.model.details.find(x => x.assetNumber == detail.assetNumber
                                && x.invoiceNumber == detail.invoiceNumber);
                            detailToUpdate.isAlreadyExist = detail.isAlreadyExist;
                            detailToUpdate.imageId = detail.imageId;
                            detailToUpdate.isValid = detail.isValid;
                        });
                    }
                    this.model.details.forEach(getty => {
                        getty.salesDate = AppUtils.getFormattedDate(getty.salesDate);
                    });
                });
        });
    }

    validateModel() {

        this.model.details.map((item) => {
            const hasValidImageId = item.imageId !== null
                && item.imageId > 0
                && item.imageId.toString() !== '';

            const hasValidSoldAmount = item.grossRoyaltyInUSD !== null
                && item.grossRoyaltyInUSD > 0
                && item.grossRoyaltyInUSD.toString() !== '';

            item.isValid = hasValidImageId && hasValidSoldAmount;
        });

        this.disableSave = this.model.details.filter(x => x.isValid === false).length > 0;

    }

    cancel() {
        this.fileElem.nativeElement.value = '';
        this.file = null;
        this.model.details = new Array<GettyOrderDetailModel>();
    }

    deleteOrder(index: number) {
        this.model.details.splice(index, 1);
        this.validateModel();
        if (!this.model.details.length) {
            this.cancel();
        }
    }

    openImageSelectionModal(index: any) {
        this.imageSelectionModal.openImageSelectionModal(index);
    }

    setImageId(result: any) {
        const item = this.model.details[result.index];
        item.imageId = result.imageId;
        item.name = result.photographerName;
        item.isValid = true;
        this.validateModel();
    }

    openImage(imageId: number) {
        this.ngxSpinner.show();
        this.gettyOrderService.imageUrl(imageId).subscribe(res => {
            this.ngxSpinner.hide();
            window.open(res);
        }, error => {
            this.ngxSpinner.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }
}
